module.exports = __webpack_public_path__ + "img/Check_Green.e3d32d9e.svg";